import { useTranslation } from '@crehana/i18n';
import { ATS_SHARED_CANDIDATE_FORM } from './constants';
import type { TKeys } from './types';

export const useTranslationSharedCandidateForm = () => {
  return useTranslation<TKeys>(ATS_SHARED_CANDIDATE_FORM);
};
